import { Button } from 'common/button'
import { Text } from 'common/text'
import { StyledCustomerEmpty } from './_styled'
import { GLOBAL_ICONS } from '../../../../interface/icon'

export const CustomerEmpty = ({ ...props }) => {
  return (
    <StyledCustomerEmpty {...props}>
      <img
        className="customer-empty__banner"
        src="/img/order/order-empty.png"
        alt="empty"
      />
      <Text as="b" color="#7C88A6" style={{ marginBottom: 16 }}> Không tìm thấy dữ liệu </Text>
    </StyledCustomerEmpty>
  )
}
